// Shared label maps for the optional Career & Financial Profile.
export const EMPLOYMENT_STATUS = [
  ["employed", "Employed"], ["self_employed", "Self-employed"], ["business_owner", "Business owner"],
  ["retired", "Retired"], ["between_jobs", "Between jobs"], ["prefer_not_to_say", "Prefer not to say"],
];
export const INDUSTRY = [
  ["healthcare", "Healthcare"], ["technology", "Technology"], ["finance", "Finance"], ["law", "Law"],
  ["hospitality", "Hospitality"], ["real_estate", "Real estate"], ["education", "Education"],
  ["government", "Government"], ["other", "Other"], ["prefer_not_to_say", "Prefer not to say"],
];
export const YEARS_EXPERIENCE = [
  ["under_2", "Under 2 years"], ["2_5", "2–5 years"], ["6_10", "6–10 years"], ["11_20", "11–20 years"],
  ["over_20", "More than 20 years"], ["prefer_not_to_say", "Prefer not to say"],
];
export const EMPLOYER_TENURE = [
  ["under_1", "Less than 1 year"], ["1_3", "1–3 years"], ["4_7", "4–7 years"], ["8_15", "8–15 years"],
  ["over_15", "More than 15 years"], ["not_applicable", "Not applicable"], ["prefer_not_to_say", "Prefer not to say"],
];
export const EDUCATION = [
  ["high_school", "High school"], ["some_college", "Some college"], ["associate", "Associate degree"],
  ["bachelors", "Bachelor's degree"], ["masters", "Master's degree"], ["doctorate", "Doctorate"],
  ["trade_vocational", "Trade / vocational"], ["other", "Other"], ["prefer_not_to_say", "Prefer not to say"],
];
export const BUSINESS_OWNERSHIP = [
  ["business_owner", "Business owner"], ["business_partner", "Business partner"],
  ["no_business", "Do not own a business"], ["prefer_not_to_say", "Prefer not to say"],
];
export const INCOME_RANGE = [
  ["under_30k", "Under $30,000"], ["30k_50k", "$30,000–$49,999"], ["50k_75k", "$50,000–$74,999"],
  ["75k_100k", "$75,000–$99,999"], ["100k_150k", "$100,000–$149,999"], ["150k_250k", "$150,000–$249,999"],
  ["250k_500k", "$250,000–$499,999"], ["500k_plus", "$500,000 or more"], ["prefer_not_to_disclose", "Prefer not to disclose"],
];
export const INCOME_SOURCES = [
  ["employment", "Employment"], ["business_ownership", "Business ownership"],
  ["self_employment", "Self-employment / consulting"], ["investments", "Investments"],
  ["retirement", "Retirement income"], ["multiple", "Multiple sources"],
];
export const FINANCIAL_LIFESTYLE = [
  ["budget_conscious", "Budget-conscious"], ["balanced", "Balanced"],
  ["upscale", "Enjoys an upscale lifestyle"], ["prefer_not_to_say", "Prefer not to say"],
];
export const FINANCIAL_GOALS = [
  ["building_wealth", "Building wealth"], ["home_ownership", "Home ownership"],
  ["business_growth", "Business growth"], ["retirement_planning", "Retirement planning"],
  ["travel_experiences", "Travel and experiences"], ["enjoying_life", "Enjoying life"],
];
export const FINANCE_RELATIONSHIP = [
  ["shared_goals", "Shared financial goals"], ["financial_independence", "Financial independence"],
  ["discuss_privately", "Prefer to discuss privately as it develops"], ["prefer_not_to_disclose", "Prefer not to disclose"],
];
export const labelOf = (list, key) => (list.find(([k]) => k === key) || [null, null])[1];
